export default {"gitHash":"d3eb9157614546de2370649f5441dbb710e8310f","gitHashShort":"d3eb915","time":1683584728240,"platform":"linux","arch":"x64"};